import {camelizeKeys} from 'humps'
import useSWR, {mutate} from 'swr'
import {useRails} from '../../contexts/rails'
import {fetcher} from '../../../api'
import useFeatureFlags from '../../hooks/useFeatureFlags'
import calculateCurrentStep from './calculateCurrentStep'
import generateCashinSteps from './steps'

export const cashinStepperKey = (supplierId) =>
  `/api/suppliers/${supplierId}/cashin_stepper`

// Helper function to refresh stepper data from anywhere
export const refreshStepperData = () => {
  return mutate(
    (key) => typeof key === 'string' && key.endsWith('/cashin_stepper'),
  )
}

export default function useStepperData({pauseFetching = false} = {}) {
  const {accountingProvider, organisation} = useRails()
  const supplierId = organisation.currentSupplier?.id
  const {
    data,
    isLoading: loadingData,
    mutate: mutateStepperData,
  } = useSWR(
    !pauseFetching && supplierId ? cashinStepperKey(supplierId) : null,
    fetcher,
  )

  const {
    data: {features},
    loading: loadingFeatures,
  } = useFeatureFlags()
  const stepperData = {
    ...camelizeKeys(data?.stepper || {}),
    features: features || {},
  }

  const isLoading = loadingData || loadingFeatures

  const currentStep = calculateCurrentStep(stepperData)
  const cashinSteps = generateCashinSteps({
    ...stepperData,
    currentStep,
    accountingProvider,
  })

  // The dashboard stepper and the cash-in page reminder must agree on whether
  // onboarding is done, so both read completion from the steps themselves
  // rather than deriving it separately.
  const completedAllSteps = cashinSteps.every(
    (step) => step.status === 'completed',
  )

  return {
    isLoading,
    cashinSteps,
    currentStep,
    completedAllSteps,
    refreshStepperData: mutateStepperData,
  }
}
